import { BaseMapper } from '@ps/utils';
import { SurveyDashboardChange } from '@ps/survey-utils';

import { SurveyDashboardSocketDto } from '../dtos/survey-socket.dto';

export class SurveyDashboardSocketMapper extends BaseMapper<
  SurveyDashboardSocketDto,
  SurveyDashboardChange
> {
  public fromDto({
    surveyManagement,
  }: SurveyDashboardSocketDto): SurveyDashboardChange {
    return {
      surveyId: surveyManagement.survey_id,
      fielded: surveyManagement.fielded,
    };
  }
}
